import React from 'react'
import logo from "../assets/img/logo.svg"
import prev_arrow from "../assets/img/prev_arrow.svg"
import next_arrow from "../assets/img/next_arrow.svg"

const Step9 = ({setStep,Submit,setStep9Status}) => {
  return (
    <>
      {/* <section class="step_wrapper"> */}
        <div class="top_logo_block">
            <div class="logo">
            <a href=""><img src={logo} alt=""/></a>
            </div>
        </div>

        <div class="step_body">
            <div class="step_form">
                <div class="form_block box_width_sm_one">
                    <h1>Submit</h1>
                    <div class="input_fields">
                        <p class="sm_txt">Please hit the "Submit" button on the bottom to record your answers</p>
                    </div>
                </div>
                <div class="btn_block">
                    <a onClick={()=>setStep(8)}> <img src={prev_arrow} alt=""/> <span>Prev</span> </a>
                    <a onClick={()=>Submit()}> <span>Submit</span> <img src={next_arrow} alt=""/></a>
                </div>
            </div>
        </div>

        {/* <div class="bottom_steps">
        <ul class="for_desktop">
            <li onClick={()=>setStep(1)} >
              <span>Referrals</span>
            </li>
            <li onClick={()=>setStep(2)} >
              <span>Your details</span>
            </li>
            <li onClick={()=>setStep(3)} >
              <span>Profession</span>
            </li>
            <li onClick={()=>setStep(4)} >
              <span>Ideal Client</span>
            </li>
            <li onClick={()=>setStep(5)} >
              <span>Good referral partners</span>
            </li>
            <li onClick={()=>setStep(6)} >
              <span>Date of birth</span>
            </li>
            <li onClick={()=>setStep(7)}>
              <span>Communication channel</span>
            </li>
            <li onClick={()=>setStep(8)} >
              <span>Hobbies</span>
            </li>
            <li onClick={()=>setStep(9)} class="active">
              <span>Submit</span>
            </li>
          </ul>
            <div class="step_for_mob">
                <p><span>9</span> of 9</p>
            </div>
        </div>
    </section> */}

    </>
  )
}

export default Step9
